<template>
  <div>
    <b-row align-h="center">
      <amplify-authenticator :authConfig="authConfig"/>
    </b-row>
  </div>
</template>
<script>
export default {
  name: 'Authenticator',
  data () {
    return {
      authConfig: {
        signInConfig: {
          isSignUpDisplayed: false
        }
      }
    }
  }
}
</script>
